import { CronJobPayload } from '../../CronJobsCRUDForm.types';

export const converter = (value: CronJobPayload) =>
  ({
    ...{
      importDefinitionId: '',
      ...value,
      config: {
        ...value.config
      }
    },

    ...(value.config.reportDefinitionId === ''
      ? { reportDefinitionId: '' }
      : {}),

    ...(value.config.period?.toString() === '' ? { period: '' } : {})
  }) as CronJobPayload;
